"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _framerMotion = require("framer-motion");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("../../Icon/Icon"));

var _MotionFlex = _interopRequireDefault(require("../../motionComponents/MotionFlex/MotionFlex"));

var _Text = _interopRequireDefault(require("../../Text/Text"));

var _OptionImage = _interopRequireDefault(require("./OptionImage"));

/* eslint-disable react/jsx-props-no-spreading */
var OverFlowText = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "Option__OverFlowText",
  componentId: "sc-1m0g6r6-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;"]);

var Option = function Option(_ref) {
  var optionConfig = _ref.optionConfig,
      onSelect = _ref.onSelect,
      textStyle = _ref.textStyle,
      iconStyle = _ref.iconStyle,
      optionIconSize = _ref.optionIconSize,
      optionImageStyling = _ref.optionImageStyling,
      optionHeight = _ref.optionHeight,
      selected = _ref.selected,
      index = _ref.index,
      accessibleItemProps = _ref.accessibleItemProps;
  var optionVariants = {
    unActive: {
      opacity: 0,
      background: "rgba(0, 0, 0, 0.0)",
      transition: {
        ease: "easeInOut",
        duration: 0.12
      }
    },
    active: {
      opacity: 1,
      background: "rgba(0, 0, 0, 0.0)",
      transition: {
        ease: "easeInOut",
        duration: 0.12
      }
    },
    selected: {
      background: "rgba(0, 0, 0, 0.1)",
      opacity: 1,
      transition: {
        ease: "easeInOut",
        duration: 0.12,
        delay: 0
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    key: optionConfig.id
  }, /*#__PURE__*/_react["default"].createElement(_MotionFlex["default"], (0, _extends2["default"])({}, accessibleItemProps, {
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        onSelect(optionConfig.id);
      }

      accessibleItemProps.onKeyDown(e);
    },
    onTap: function onTap() {
      onSelect(optionConfig.id);
    },
    style: {
      width: "100%",
      cursor: "pointer"
    },
    id: optionConfig.id,
    variants: optionVariants,
    animate: selected ? "selected" : "active",
    whileHover: "selected" // @ts-ignore
    ,
    minHeight: optionHeight,
    width: 1 / 1,
    alignItems: "center",
    alignContent: "center",
    mt: index === 0 ? 1 : 0,
    title: optionConfig.value,
    "aria-label": selected ? "" + optionConfig.value : "",
    "aria-selected": selected
  }), optionConfig.icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    name: optionConfig.icon,
    size: optionIconSize
  }, iconStyle, {
    "aria-hidden": true
  })), optionConfig.image && /*#__PURE__*/_react["default"].createElement(_OptionImage["default"], {
    src: optionConfig.image,
    style: optionImageStyling,
    "aria-hidden": true
  }), /*#__PURE__*/_react["default"].createElement(OverFlowText, (0, _extends2["default"])({
    width: 1 / 1,
    id: optionConfig.id
  }, textStyle), optionConfig.value)));
};

var _default = Option;
exports["default"] = _default;